import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPasswordScreen } from '@/screens/accounts/SCR-104-105-password'

// SCR-105 Reset password (accounts area).
export const Route = createFileRoute('/_public/reset-password')({
  validateSearch: z.object({
    token: z.string().max(200).optional().catch(undefined),
    error: z.string().max(100).optional().catch(undefined),
  }),
  component: function ResetPassword() {
    return <ResetPasswordScreen search={Route.useSearch()} />
  },
})
